import React from "react";
import SectionHero from "components/SectionHero/SectionHero";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
// lista stanze disponiibili dashboard
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces.jsx";
import SectionHowItWork from "components/SectionHowItWork/SectionHowItWork";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { TaxonomyType } from "data/types";
import SectionGridAuthorBox from "components/SectionGridAuthorBox/SectionGridAuthorBox"; // non toccare per il momento
import SectionBecomeAnAuthor from "components/SectionBecomeAnAuthor/SectionBecomeAnAuthor";
import SectionVideos from "./SectionVideos";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";

import SezioneCaroselloPaesaggi from "containers/PageHome/SezioneCaroselloPaesaggi.jsx"



const DEMO_CATS_2: TaxonomyType[] = [
  {
    id: "2",
    href: "/listing-stay",
    name: "Da Peppino in Villa Greco N.5",
    taxonomy: "category",
    count: 188288,
    thumbnail:
    "https://i.ibb.co/3svfhh4/20241120-173020.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "3",
    href: "/listing-stay",
    name: "Bouganville in Villa Greco N.3",
    taxonomy: "category",
    count: 188288,
    thumbnail:
    "https://i.ibb.co/h9pGwMj/20241120-171424.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "4",
    href: "/listing-stay",
    name: "Il gelso in Villa Greco N.4",
    taxonomy: "category",
    count: 188288,
    thumbnail:
    "https://i.ibb.co/rxM7Gwg/547613772.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "5",
    href: "/listing-stay",
    name: "L'ulivo in Villa Greco N.5",
    taxonomy: "category",
    count: 188288,
    thumbnail:
    "https://i.ibb.co/C5KztX0/20241120-161607.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "1",
    href: "/listing-stay",
    name: "Belvedere in Villa Greco N.1",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://i.ibb.co/KLJpmLs/20241120-164501.jpg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
  },
];

function PageHome() {
  return (
    <div className="nc-PageHome relative overflow-hidden">
      {/* GLASSMOPHIN */}
      <BgGlassmorphism />

      <div className="container relative space-y-24 mb-24 lg:space-y-28 lg:mb-28">
        {/* SECTION HERO */}
        <SectionHero className="pt-10 lg:pt-16 lg:pb-16" />

        {/* SECTION 1 */}
          {/* <SectionSliderNewCategories 
          categories={DEMO_CATS}
          uniqueClassName="PageHome_s1"
        />  */}


        {/* SECTION */}
        {/* lista stanze dashboard */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionGridFeaturePlaces />
        </div>

        {/* SECTION carosello esterno */}
        <SezioneCaroselloPaesaggi />
        
        {/* SECTION */}
        {/* video tindari */}
        <SectionVideos />

                {/* SECTION */}
        {/* perchè scegliere villa greco */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionBecomeAnAuthor />
        </div>

          

        {/* SECTION */}
        <SectionHowItWork />

       

         {/* SECTION */}
        {/* newsletter */}
        <div className="relative py-16">
          <BackgroundSection className="bg-orange-50 dark:bg-black dark:bg-opacity-20 " />
        <SectionSubscribe2 />
        </div>



        {/* SECTION */}
        {/* <div className="relative py-16">
          <BackgroundSection className="bg-orange-50 dark:bg-black dark:bg-opacity-20 " />
          <SectionGridAuthorBox />
        </div> */}




        {/* SECTION 1 */}
        {/* <SectionSliderNewCategories
          heading="Explore by types of stays"
          subHeading="Explore houses based on 10 types of stays"
          categoryCardType="card5"
          itemPerRow={5}
          uniqueClassName="PageHome_s3"
        /> */}




        {/* SECTION */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay uniqueClassName="PageHome_" />
        </div>

             
      </div>
    </div>
  );
}

export default PageHome;
